import { VariantDetailWindow } from 'productTemplate/components/windows/VariantDetailWindow';
import { useStoreSelector } from 'store/hooks/storeHooks';

export const BuyBarDesktopOpenWindows = () => {
  const { openWindows } = useStoreSelector((state) => state.pdpState);

  return (
    <>
      {openWindows.map((variantData) => (
        <VariantDetailWindow key={variantData.id} variantData={variantData} />
      ))}
    </>
  );
};
